import { THEME_AND_SETTINGS_FETCHED, THEME_SETTINGS_VARIANT_FETCHED, THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_BUFFER_SAVED, THEME_SETTINGS_CHANGE_REDONE, THEME_SETTINGS_CHANGE_UNDONE, THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES, THEME_SETTINGS_FIELD_KEY_UPDATED, THEME_SETTINGS_REVERTED, THEME_SETTINGS_REVISIONS_FETCHED, THEME_SETTINGS_UPDATED, THEME_SETTINGS_RESET, THEME_SETTINGS_CLEARED, FETCH_THEME_SUCCEEDED } from './ActionTypes';
import * as themesClient from '../api/ThemesClient';
import * as themeSettingsClient from '../api/ThemeSettingsClient';
import * as settingsSelectors from '../selectors/themeSettingsSelectors';
import { getTestMode } from '../selectors/appSelectors';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { markActionComplete } from 'user-context/onboarding';
const fetchThemeAndSettingsRequested = () => ({
  type: THEME_AND_SETTINGS_FETCHED,
  requestStatus: RequestStatusTypes.PENDING
});
const fetchThemeAndSettingsSucceeded = payload => ({
  type: THEME_AND_SETTINGS_FETCHED,
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchThemeAndSettingsFailed = error => ({
  type: THEME_AND_SETTINGS_FETCHED,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchThemeAndSettings = (themePath, themeVariant) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchThemeAndSettingsRequested());
    const testMode = getTestMode(state);
    // TODO: Handle test_mode variant using generic themeVariant query param
    const _themeVariant = testMode ? 'test_mode' : themeVariant;
    return themesClient.fetchThemeAndSettings(themePath, _themeVariant).then(({
      activeThemePresetId,
      theme,
      themeSettings
    }) => {
      const payload = {
        activeThemePresetId,
        theme,
        themeSettings
      };
      dispatch(fetchThemeAndSettingsSucceeded(payload));
      return payload;
    }, error => {
      if (error.status) dispatch(fetchThemeAndSettingsFailed(error));
      throw error;
    });
  };
};
const themeSettingsVariantRequested = () => ({
  type: THEME_SETTINGS_VARIANT_FETCHED,
  requestStatus: RequestStatusTypes.PENDING
});
const themeSettingsVariantReceived = payload => ({
  type: THEME_SETTINGS_VARIANT_FETCHED,
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const themeSettingsVariantFetchFailed = error => ({
  type: THEME_SETTINGS_VARIANT_FETCHED,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchThemeSettingsVariant = (themePath, variantName) => {
  return dispatch => {
    dispatch(themeSettingsVariantRequested());
    return themeSettingsClient.fetchThemeVariant(themePath, variantName).then(result => {
      dispatch(themeSettingsVariantReceived(result));
      return result;
    }, error => {
      if (error.status) dispatch(themeSettingsVariantFetchFailed(error));
      throw error;
    });
  };
};
const saveSettingsBufferRequested = () => ({
  type: THEME_SETTINGS_BUFFER_SAVED,
  requestStatus: RequestStatusTypes.PENDING
});
const saveSettingsBufferSucceeded = payload => ({
  type: THEME_SETTINGS_BUFFER_SAVED,
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const saveSettingsBufferFailed = error => ({
  type: THEME_SETTINGS_BUFFER_SAVED,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const saveSettingsBuffer = ({
  isAutoSave
}) => {
  return (dispatch, getState) => {
    const state = getState();
    const settingsId = settingsSelectors.getThemeSettingsId(state);
    const values = settingsSelectors.getThemeSettingsValues(state);
    const breakpointStyles = settingsSelectors.getThemeBreakpointStyles(state);
    dispatch(saveSettingsBufferRequested());
    themeSettingsClient.saveBuffer(settingsId, {
      breakpointStyles,
      values
    }).then(payload => {
      //@ts-expect-error FIXME: update payload type when CHIRP exports field value types and fully ungaqted
      dispatch(saveSettingsBufferSucceeded(Object.assign({}, payload, {
        isAutoSave
      })));
    }).catch(error => {
      if (error.status) dispatch(saveSettingsBufferFailed(error));
      throw error;
    });
  };
};
const publishSettingsBufferRequested = () => ({
  type: THEME_SETTINGS_BUFFER_PUBLISHED,
  requestStatus: RequestStatusTypes.PENDING
});
const publishSettingsBufferSucceeded = payload => ({
  type: THEME_SETTINGS_BUFFER_PUBLISHED,
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const publishSettingsBufferFailed = error => ({
  type: THEME_SETTINGS_BUFFER_PUBLISHED,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const publishSettingsBuffer = () => {
  return (dispatch, getState) => {
    const state = getState();
    const settingsId = settingsSelectors.getThemeSettingsId(state);
    dispatch(publishSettingsBufferRequested());
    themeSettingsClient.publishBuffer(settingsId).then(payload => {
      dispatch(publishSettingsBufferSucceeded(payload));
      markActionComplete('select-style-v2').catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }).catch(error => {
      if (error.status) {
        dispatch(publishSettingsBufferFailed(error));
        return;
      }
      throw error;
    });
  };
};
const themeSettingsUpdated = ({
  breakpoint,
  key,
  themeSettings,
  value
}) => ({
  type: THEME_SETTINGS_UPDATED,
  payload: {
    breakpoint,
    key,
    themeSettings,
    value
  }
});
export const updateSettings = ({
  breakpoint,
  key,
  themeSettings,
  value
}) => {
  return dispatch => {
    dispatch(themeSettingsUpdated({
      breakpoint,
      key,
      themeSettings,
      value
    }));
  };
};
const redoChangeAction = () => ({
  type: THEME_SETTINGS_CHANGE_REDONE
});
export const redoChange = () => {
  return dispatch => {
    dispatch(redoChangeAction());
  };
};
const clearThemeSettingsAction = () => ({
  type: THEME_SETTINGS_CLEARED
});
export const clearThemeSettings = () => {
  return dispatch => {
    dispatch(clearThemeSettingsAction());
  };
};
const undoChangeAction = () => ({
  type: THEME_SETTINGS_CHANGE_UNDONE
});
export const undoChange = () => {
  return dispatch => {
    dispatch(undoChangeAction());
  };
};
const fetchHasBufferedSettingsChangesRequested = () => ({
  type: THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES,
  requestStatus: RequestStatusTypes.PENDING
});
const fetchHasBufferedSettingsChangesSucceeded = (hasChanges, changes) => ({
  type: THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES,
  payload: {
    hasChanges,
    changes
  },
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchHasBufferedSettingsChangesFailed = error => ({
  type: THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchHasBufferedSettingsChanges = () => {
  return (dispatch, getState) => {
    const state = getState();
    const settingsId = settingsSelectors.getThemeSettingsId(state);
    const settingsValues = settingsSelectors.getThemeSettingsValues(state);
    dispatch(fetchHasBufferedSettingsChangesRequested());
    themeSettingsClient.hasBufferedChanges(settingsId).then(result => {
      const hasChanges = result.has_changes;
      const changes = hasChanges ? settingsValues : null;
      dispatch(fetchHasBufferedSettingsChangesSucceeded(hasChanges, changes));
    }).catch(error => {
      if (error.status) {
        dispatch(fetchHasBufferedSettingsChangesFailed(error));
        return;
      }
      throw error;
    });
  };
};
export const updateSettingsFieldKey = fieldKey => {
  return {
    type: THEME_SETTINGS_FIELD_KEY_UPDATED,
    payload: fieldKey
  };
};
const fetchRevisionsRequested = () => ({
  type: THEME_SETTINGS_REVISIONS_FETCHED,
  requestStatus: RequestStatusTypes.PENDING
});
const fetchRevisionsSucceeded = payload => ({
  type: THEME_SETTINGS_REVISIONS_FETCHED,
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchRevisionsFailed = error => ({
  type: THEME_SETTINGS_REVISIONS_FETCHED,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchRevisions = offset => (dispatch, getState) => {
  const state = getState();
  const settingsId = settingsSelectors.getThemeSettingsId(state);
  dispatch(fetchRevisionsRequested());
  themeSettingsClient.fetchRevisions(settingsId, {
    offset
  }).then(payload => {
    //@ts-expect-error FIXME: this won't be needed when we get rid of old type before CHIRP
    dispatch(fetchRevisionsSucceeded(payload));
  }).catch(error => {
    if (error.status) {
      dispatch(fetchRevisionsFailed(error));
      return;
    }
    throw error;
  });
};
const revertThemeSettingsRequested = () => ({
  type: THEME_SETTINGS_REVERTED,
  requestStatus: RequestStatusTypes.PENDING
});
const revertThemeSettingsSucceeded = () => ({
  type: THEME_SETTINGS_REVERTED,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const revertThemeSettingsFailed = error => ({
  type: THEME_SETTINGS_REVERTED,
  error: true,
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const revertThemeSettings = versionId => (dispatch, getState) => {
  const state = getState();
  const settingsId = settingsSelectors.getThemeSettingsId(state);
  dispatch(revertThemeSettingsRequested());
  themeSettingsClient.revertThemeSettings(settingsId, {
    versionId
  }).then(() => {
    dispatch(revertThemeSettingsSucceeded());
  }).catch(error => {
    if (error.status) {
      dispatch(revertThemeSettingsFailed(error));
      return;
    }
    throw error;
  });
};
const themeSettingsReset = (key, breakpoint) => ({
  type: THEME_SETTINGS_RESET,
  payload: {
    breakpoint,
    key
  }
});

//used just for ts type so we can handle CEUI action
const fetchThemeSucceeded = (payload, response) => ({
  type: FETCH_THEME_SUCCEEDED,
  payload,
  response,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
export const resetFieldSettings = (key, breakpoint) => dispatch => {
  dispatch(themeSettingsReset(key, breakpoint));
};